import api from './api';

const opportuniteService = {
  // Routes publiques
  getAll: (params = {}) => {
    return api.get('/opportunites', { params });
  },

  getRecent: () => {
    return api.get('/opportunites/recent');
  },

  getBySlug: (slug) => {
    return api.get(`/opportunites/${slug}`);
  },

  proposer: (data) => {
    return api.post('/opportunites/proposer', data);
  },

  postuler: (data) => {
    return api.post('/opportunites/postuler', data);
  },

  // Routes admin
  admin: {
    getAll: (params = {}) => {
      return api.get('/admin/opportunites', { params });
    },

    getById: (id) => {
      return api.get(`/admin/opportunites/${id}`);
    },

    create: (data) => {
      return api.post('/admin/opportunites', data);
    },

    update: (id, data) => {
      // Si c'est un FormData, utiliser POST avec _method=PUT pour Laravel
      if (data instanceof FormData) {
        return api.post(`/admin/opportunites/${id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      return api.put(`/admin/opportunites/${id}`, data);
    },

    delete: (id) => {
      return api.delete(`/admin/opportunites/${id}`);
    },

    getStatistiques: () => {
      return api.get('/admin/opportunites/statistiques');
    }
  }
};

export default opportuniteService;

